export const THIRD = '#fff';
export const BORDER_COLOR = '#e7e7e7';
export const INPUT_BORDER_COLOR = '#e7e7e7';
